import ajax from '@/utils/ajax';

export const head = '/web';

// 获取模考信息
export const getExamDataApi = (data) => ajax(`${head}/v1/question-bank/exam/base-info?businessLine=${data.businessLine}&examId=${data.examId}`);
